import React, { FC, PropsWithChildren } from "react"
import { useAuth } from "../../../../contexts/authentication-context"

type RequiresRoleProps = {
    role: string
}

const RequiresRole: FC<PropsWithChildren<RequiresRoleProps>> = ({ role, children }) => {
    const { hasRole } = useAuth()

    if (hasRole(role)) return <>{children}</>
    else return null
}

export default RequiresRole
